import { createTheme } from '@mui/material/styles';
import uiSettings from '../config/uiSettings';

const { colors, fontFamily, radius } = uiSettings;

export const appTheme = createTheme({
  direction: uiSettings.direction,
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary,
      dark: colors.primaryDark,
      light: colors.primaryLight,
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: colors.secondary,
      contrastText: '#FFFFFF'
    },
    background: {
      default: colors.background,
      paper: colors.surface
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary
    },
    success: { main: colors.success },
    warning: { main: colors.warning },
    error: { main: colors.error },
    info: { main: colors.info },
    divider: colors.border
  },
  typography: {
    fontFamily,
    button: {
      textTransform: 'none',
      fontWeight: 600
    }
  },
  shape: {
    borderRadius: radius.md
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: radius.md,
          fontWeight: 600
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: radius.md,
          border: `1px solid ${colors.border}`,
          boxShadow: 'none'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: radius.md
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        size: 'small'
      }
    }
  }
});

export default appTheme;
